import React from 'react';

const IconItemPreview = ({ icon, size }) => {
	const width = size === 'small' ? '80px' : '120px';
	const style = size === 'full' ? { flex: 1 } : { width, height: width };
	return (
		<div className="icon-image" style={style}>
			<img
				src={icon.source.src}
				style={{
					width: '100%',
					aspectRatio: 1,
					objectFit: 'contain',
				}}
				alt={`icon-item-preview-${icon.source.name}`}
			/>
		</div>
	);
};

export default IconItemPreview;
